module.exports = __webpack_public_path__ + "static/media/سائق عربي في سويسرا.12914ad2.jpg";